import _objectWithoutProperties from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "isDisabled", "__css"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/close-button.tsx
import { Icon } from "@chakra-ui/icon";
import { chakra, forwardRef, omitThemingProps, useStyleConfig } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
function CloseIcon(props) {
  return /* @__PURE__ */jsx(Icon, _objectSpread(_objectSpread({
    focusable: "false",
    "aria-hidden": true
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    })
  }));
}
var CloseButton = forwardRef(function CloseButton2(props, ref) {
  var styles = useStyleConfig("CloseButton", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    isDisabled = _omitThemingProps.isDisabled,
    __css = _omitThemingProps.__css,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var baseStyle = {
    outline: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  };
  return /* @__PURE__ */jsx(chakra.button, _objectSpread(_objectSpread({
    type: "button",
    "aria-label": "Close",
    ref: ref,
    disabled: isDisabled,
    __css: _objectSpread(_objectSpread(_objectSpread({}, baseStyle), styles), __css)
  }, rest), {}, {
    children: children || /* @__PURE__ */jsx(CloseIcon, {
      width: "1em",
      height: "1em"
    })
  }));
});
CloseButton.displayName = "CloseButton";
export { CloseButton };